export function setBirths (state, births) {
    state.births = births;
  }
  
  export function setBirth (state, birth){
    state.selectedBirth = birth
  }
  
  export function birthsError(state, payload){
    state.error = true
    state.errorMessage = payload
    state.births = []
  }
  